import { useEffect, useState } from 'react';
import { Outlet, useParams } from 'react-router-dom';
// material
import { styled, useTheme } from '@mui/material/styles';
// hooks
import useCollapseDrawer from '../../hooks/useCollapseDrawer';
import { TopbarSlotsProvider } from '../../contexts/TopbarSlotsContext';
import { TourProvider } from '../../components/tour/TourProvider';
//
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import useAuth from '../../hooks/useAuth';
import UserAfterRegistration from '../../pages/dashboard/UserAfterRegistration';
import {
  useGetLatestInvitationQuery,
  useGetConsultancySettingsQuery,
} from '../../redux/slices/api';
import { defaultsConfig } from '../../config';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 14,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: 0,
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const theme = useTheme();
  const { collapseClick } = useCollapseDrawer();
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const {
    data: invitation,
    isFetching,
    refetch,
  } = useGetLatestInvitationQuery({ email: user.email });
  const { data: consultancySettings } = useGetConsultancySettingsQuery();
  if (consultancySettings) Object.assign(defaultsConfig, consultancySettings);

  useEffect(() => {
    if (user?.displayName) {
      refetch();
    }
  }, [user]);

  const isInvitationApprove = !isFetching && invitation?.length && !invitation[0]?.is_approved;
  return (
    <TopbarSlotsProvider>
      <TourProvider>
        <RootStyle>
          <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
          <DashboardSidebar isOpenSidebar={open} onCloseSidebar={() => setOpen(false)} />
          <MainStyle
            sx={{
              transition: theme.transitions.create('margin', {
                duration: theme.transitions.duration.complex,
              }),
              ...(collapseClick && {
                ml: '102px',
              }),
            }}
          >
            {isInvitationApprove || user?.displayName === '' ? (
              <UserAfterRegistration
                isInvitationApprove={isInvitationApprove}
                id={isInvitationApprove && invitation[0]?.id}
              />
            ) : (
              <Outlet />
            )}
          </MainStyle>
        </RootStyle>
      </TourProvider>
    </TopbarSlotsProvider>
  );
}
